import type { DataGridProps, GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import { AoaTable } from '../../atoms/table/Table';

export interface AoaFileTableProps<T extends GridValidRowModel = any> {
  /**
   * The column structure to display the data
   */
  columns: GridColDef<T>[];
  /**
   * The TableData object to be displayed in the table
   */
  data: T[];
  /**
   * Data-qa tag for E2E test purposes
   */
  'data-qa'?: string;
  /**
   * Overwrite a safe selection of the {@link DataGrid} properties
   */
  dataGridOverridableProps?: Pick<DataGridProps<T>, 'getRowId' | 'ignoreDiacritics'>;
  /**
   * Sets the initial sortModel in case the required sorting differs from the back-end's default sorting
   */
  initialSort?: {
    field: string;
    sort: 'asc' | 'desc';
  };
}

export function AoaFileTable<T extends object = any>({
  data,
  columns,
  initialSort,
  dataGridOverridableProps,
  'data-qa': dataQa
}: Readonly<AoaFileTableProps<T>>) {
  return (
    <AoaTable<T>
      columns={columns}
      data={{
        rows: data ?? [],
        rowCount: data?.length ?? 0
      }}
      data-qa={dataQa}
      dataGridOverridableProps={dataGridOverridableProps}
      initialSort={initialSort}
      mode='client'
    />
  );
}
